import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { useCheckDevice } from '../../../hooks/UseCheckDevice';
import { Icon } from '../../style/Icon';
import { Typography } from '../../style/Typography';

export type ToastNotificationProps = {
  toastMessage: string;
  iconType: string;
  iconColor: string;
  leftIndicatorColor: string;
  backgroundColor?: string;
};

type WrapperProps = {
  color?: string;
};

const ToastNotification: FC<ToastNotificationProps> = (props) => {
  const { isMobileDevice } = useCheckDevice();

  const toastContentLimit = 200;
  const toastMessageArray = (
    props.toastMessage.length > toastContentLimit
      ? props.toastMessage.slice(0, toastContentLimit) + '...'
      : props.toastMessage
  ).split('\n');

  function getIconColor(iconType: string) {
    if (iconType === 'checkmark') {
      return theme.palette.white;
    }
    if (iconType === 'x-circle-full') {
      return theme.palette.toastError;
    }
    if (iconType === 'info') {
      return theme.palette.toastInfo;
    }
    if (iconType === 'warning') {
      return theme.palette.toastWarning;
    }
  }

  return (
    <Wrapper data-testid='toast-notification' color={getIconColor(props.iconType)}>
      <LeftVerticalIndicator {...props} />
      <RightNotificationPanel {...props}>
        <Icon
          type={props.iconType}
          size={theme.typography.fontSize20}
          color={props.iconColor}
          className={`-icon ${isMobileDevice ? `mobile-toastr-icon${props.iconType !== 'checkmark' ? '' : ' mobile-checkmark-icon'}` : ''}`}
        />
        <MessageContainer>
          {toastMessageArray.map((message, index) => {
            return (
              <div key={index}>
                <Typography
                  size={theme.typography.fontSize14}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={!isMobileDevice ? theme.palette.white : theme.palette.darkGray}
                  key={message}
                >
                  {message}
                </Typography>
              </div>
            );
          })}
        </MessageContainer>
      </RightNotificationPanel>
    </Wrapper>
  );
};

export default ToastNotification;

const Wrapper = styled.div<WrapperProps>`
  display: flex;

  .-icon {
    padding-right: 0.7rem;
    display: inline-block;
    vertical-align: bottom;
  }

  .mobile-toastr-icon {
    color: ${(props) => props.color};
    font-size: ${theme.typography.fontSize24}px;
    font-weight: ${theme.typography.fontWeights.light};
    line-height: 1.3;
    margin-right: 12px;
  }

  .mobile-checkmark-icon {
    background: ${theme.palette.toastSuccess};
    height: 22px;
    width: 22px;
    border-radius: 50%;
    font-size: ${theme.typography.fontSize20}px;
    padding-left: 3px;
  }
`;

const LeftVerticalIndicator = styled.div<ToastNotificationProps>`
  min-width: 0.8rem;
  border-radius: 6px 0 0 6px;
`;

const RightNotificationPanel = styled.div<ToastNotificationProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.4rem 0.4rem 0.4rem 0.1rem;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
